import { Box, Grid2, Icon, IconButton, LinearProgress, Typography } from "@mui/material";
import { PRIMARY_COLOR } from "../../_const/color.const";

/** Match `AppToolbar` / MUI Toolbar heights */
const DRAWER_HEADER_HEIGHT = { xs: 56, md: 64 } as const;

export function DrawerHeader(params: {
    isFullWidth?: boolean,
    children?: React.ReactNode,
    name: string,
    isLoading?: boolean,
    onClose(): void
}) {

    return (
        <>
            <Box
                className="heading"
                sx={{
                    minHeight: DRAWER_HEADER_HEIGHT,
                    height: DRAWER_HEADER_HEIGHT,
                    px: 2,
                    pr: 1,
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "space-between",
                    gap: 1,
                    width: "100%",
                    boxSizing: "border-box",
                    backgroundColor: PRIMARY_COLOR,
                    color: "white",
                    flexShrink: 0,
                }}
            >
                <Typography
                    component="h2"
                    variant="h6"
                    sx={{
                        fontWeight: 600,
                        fontSize: { xs: "1rem", md: "1.1rem" },
                        lineHeight: 1.2,
                        flex: 1,
                        minWidth: 0,
                        overflow: "hidden",
                        textOverflow: "ellipsis",
                        whiteSpace: "nowrap",
                    }}
                >
                    {params.name}
                </Typography>
                <IconButton
                    onClick={params.onClose}
                    aria-label="Close drawer"
                    size="medium"
                    sx={{
                        color: "inherit",
                        flexShrink: 0,
                    }}
                >
                    <Icon>close</Icon>
                </IconButton>
            </Box>

            <Grid2 container spacing={1} sx={{ marginBottom: "5px", height: "15px" }}>
                <Grid2 size={{ xs: 12 }}>
                    {params.isLoading && <LinearProgress />}
                </Grid2>
            </Grid2>
        </>
    );

}
